<div class="row mb-4" [hidden]="field.hidden" [formGroup]="formGroup!">

    <label class="col-sm-2 col-form-label form-label">
        {{field.label}}
        <span class="text-danger" *ngIf="field.required"> * </span>
    </label>

    <div class="col-sm-10">


        <!-- <input class="form-control"
            [ngClass]="isInvalid && submitted ? 'is-invalid':null"
            formControlName="{{field.id}}" [readOnly]="!field.editable"
            type="text" [required]="field.required && !field.hidden!"> -->



        <div class="wrapper" style="direction: ltr;" *ngIf="!viewApp">
            <ngx-intl-tel-input [cssClass]="'form-control form-control-lg input-country-code'"
                [preferredCountries]="preferredCountries" [ngClass]="isInvalid && submitted ? 'is-invalid':null"
                [enableAutoCountrySelect]="true" [enablePlaceholder]="false" [searchCountryFlag]="true"
                [searchCountryField]="[
                    SearchCountryField.Iso2,
                    SearchCountryField.Name
                  ]" [selectFirstCountry]="true" [selectedCountryISO]="CountryISO.Jordan" [phoneValidation]="true"
                [separateDialCode]="separateDialCode" [numberFormat]="PhoneNumberFormat.National"
                formControlName="{{fieldId}}" [(ngModel)]="phoneNumber" [required]="field.required && !field.hidden!">

            </ngx-intl-tel-input>

        </div>

        <div *ngIf="viewApp==true">

            <input formControlName="{{fieldId}}" [value]="field.value" class="form-control">
        </div>
        <!-- 
              <span *ngIf="(phoneNumber==null && submitted)" class="text-danger"  >

                حقل اجباري !

            </span> -->

        <p class="pt-1" style="font-size: 13px !important;" *ngIf="field?.description">
            {{field.description}}
        </p>

        <p class="pt-1 text-danger" style="font-size: 13px !important;" *ngIf="yourTurn && field?.approved == false">
            {{field.comment}}
        </p>

        <div *ngIf="isInvalid && submitted">
            <span class="text-danger" *ngIf="errors?.['required']">
                {{'requiredField'|translate}}!
            </span>

            <span class="text-danger" *ngIf="errors?.['validatePhoneNumber']?.['valid']==false">
                {{'phone-format'|translate}}
            </span>
        </div>

    </div>


</div>